import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { PageHeaderContentProps } from "./PageHeader.types";

export function PageHeaderContent({
  children,
  className,
}: PageHeaderContentProps): JSX.Element {
  return (
    <div
      data-slot="page-header-content"
      className={clsx(styles.content, className)}
    >
      {children}
    </div>
  );
}
